export const tr = {
    newAudience: 'Yeni hedef kitle',
    newGroup: 'Yeni reklam grubu'
};
